export const TOOLS = [
  {
    slug: "phrasly-ai",
    name: "Phrasly.ai",
    short: "Phrasly",
    tagline: "The all-round AI copywriter built for freelancers and solo marketers",
    rating: 4.7,
    editorsChoice: true,
    color: "#4361EE",
    website: "https://phrasly.ai",
    affiliateKey: "phrasly",
    testedDays: 21,
    foundedYear: 2023,
    bestFor: "Freelancers & solo marketers",
    oneLiner: "The best quality-to-price ratio we tested, with genuinely fast, human-sounding first drafts.",
    pricing: [
      { plan: "Starter", price: "$19", period: "/mo", credits: "30,000 words", features: ["40+ templates", "Chrome extension", "1 brand voice"] },
      { plan: "Pro", price: "$39", period: "/mo", credits: "Unlimited words", features: ["All templates", "5 brand voices", "Zapier + WordPress", "Priority generation speed"] },
      { plan: "Agency", price: "$99", period: "/mo", credits: "Unlimited + 5 seats", features: ["Team workspace", "Client folders", "API access", "Dedicated support"] },
    ],
    pros: [
      "Fastest first-draft generation in our test group (avg. 4.2s per 150-word block)",
      "Brand voice trained from 3 samples felt noticeably more 'on-brand' than competitors",
      "Best native long-form editor with inline AI rewriting",
      "Genuinely useful Chrome extension for Gmail and LinkedIn",
    ],
    cons: [
      "Template library (40+) is smaller than what dedicated long-form tools offer",
      "No native SEO content brief tool for keyword-driven blog briefs",
      "Agency plan seat pricing gets expensive above 5 users",
    ],
    writingTypes: ["Emails", "Ads", "Blog posts", "Social captions", "Product descriptions", "Landing pages", "LinkedIn bios"],
    integrations: ["WordPress", "Zapier", "Chrome Extension", "Google Docs", "Notion"],
    ratingBreakdown: { quality: 4.8, speed: 4.9, valueForMoney: 4.6, easeOfUse: 4.7, support: 4.4 },
  },
  {
    slug: "codex-leo-ai",
    name: "Codex Leo AI",
    short: "Codex Leo",
    tagline: "The AI book writer for full-length guides, ebooks, and long-form content",
    rating: 4.5,
    editorsChoice: false,
    color: "#FF6B35",
    website: "https://codexleo.ai",
    affiliateKey: "codexleo",
    testedDays: 16,
    foundedYear: 2024,
    bestFor: "Long-form books, guides & ebooks",
    oneLiner: "The only tool in this comparison built to write a complete, structured book — not just a single draft.",
    pricing: [
      { plan: "Free", price: "$0", period: "", credits: "10,000 tokens (one-time)", features: ["Full outline builder", "All 4 export formats", "No credit card required"] },
      { plan: "Starter Pack", price: "$19", period: "one-time", credits: "~25,000 tokens", features: ["Enough for a short ebook", "Tokens never expire", "60-day money-back guarantee"] },
      { plan: "Author Pack", price: "$79", period: "one-time", credits: "~150,000 tokens", features: ["Enough for a full-length nonfiction book", "Cover + chapter image uploads", "Priority generation queue"] },
    ],
    pros: [
      "Only tool tested that outlines a full chapter structure before writing a single word",
      "Pay-per-word token model — no forced monthly subscription, tokens never expire",
      "Exports directly to PDF, DOCX, EPUB, and HTML, ready to publish",
      "Every chapter revision is saved, so you can roll back instead of losing a draft",
    ],
    cons: [
      "Not built for quick single emails, captions, or ad variations — Phrasly and Rytr are faster for that",
      "No Chrome extension or Zapier integration for in-app writing",
      "Token costs can add up fast on very long, image-heavy books",
    ],
    writingTypes: ["Full-length books", "Ebooks & guides", "Chapter outlines", "Long-form nonfiction", "How-to manuals", "Course workbooks"],
    integrations: ["PDF export", "DOCX export", "EPUB export", "HTML export"],
    ratingBreakdown: { quality: 4.7, speed: 4.0, valueForMoney: 4.6, easeOfUse: 4.5, support: 4.1 },
  },
  {
    slug: "rytr",
    name: "Rytr",
    short: "Rytr",
    tagline: "The budget-friendly AI writer for solo creators and side hustlers",
    rating: 4.0,
    editorsChoice: false,
    color: "#F72585",
    website: "https://rytr.me",
    affiliateKey: "rytr",
    testedDays: 12,
    foundedYear: 2021,
    bestFor: "Solo creators on a budget",
    oneLiner: "The cheapest tool in our test group that still produces genuinely usable short-form copy.",
    pricing: [
      { plan: "Free", price: "$0", period: "/mo", credits: "10,000 characters/mo", features: ["All 40+ use cases", "Basic tone options"] },
      { plan: "Saver", price: "$9", period: "/mo", credits: "100,000 characters/mo", features: ["Premium personas", "Plagiarism checker"] },
      { plan: "Unlimited", price: "$29", period: "/mo", credits: "Unlimited", features: ["All features", "Priority speed"] },
    ],
    pros: [
      "Lowest price point of any tool that still felt production-ready",
      "Clean, distraction-free interface, fastest to learn",
      "Built-in plagiarism checker at no extra cost",
    ],
    cons: [
      "Struggles with longer-form content over ~800 words",
      "Fewer integrations than premium competitors",
      "Brand voice customization is more limited",
    ],
    writingTypes: ["Social captions", "Ads", "Emails", "Product descriptions", "LinkedIn bios"],
    integrations: ["Chrome Extension", "Zapier"],
    ratingBreakdown: { quality: 3.9, speed: 4.3, valueForMoney: 4.8, easeOfUse: 4.5, support: 3.6 },
  },
];

export const getToolBySlug = (slug) => TOOLS.find((t) => t.slug === slug);
export const getToolByAffiliateKey = (key) => TOOLS.find((t) => t.affiliateKey === key);
